export default "__VITE_IMAGE_ASSET__bd5bd63f__";